/* src/app/login/login.component.css */
:host {
  display: block;
  min-height: 100vh;
  --panel-bg: #ffffff;
  --surface: #f6f2e9;
  --surface-accent: #efe6d4;
  --ink: #15323b;
  --muted: #5d6a71;
  --line: #d8cdb9;
  --brand: #0d6d66;
  --brand-deep: #114f58;
  --brand-soft: #d7f0eb;
  --accent: #c96b2c;
}
.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background: transparent;
}
.login-panel {
  width: 100%;
  max-width: 700px;
  padding: 32px;
  background: var(--panel-bg);
  border: 1px solid rgba(21, 50, 59, 0.08);
  border-radius: 28px;
  box-shadow: 0 28px 70px rgba(21, 50, 59, 0.12);
}
.login-panel > p-progressBar {
  display: block;
  margin-bottom: 28px;
}
.logo-container {
  text-align: center;
  margin-bottom: 28px;
}
.app-title {
  margin: 16px 0 8px;
  color: var(--ink);
  font-size: 2rem;
  line-height: 1.15;
}
.subtitle {
  margin: 0;
  color: var(--muted);
  font-size: 1rem;
}
.login-tabs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  border-radius: 22px;
  background: var(--surface);
  margin-bottom: 24px;
}
.tab-button {
  border: 0;
  border-radius: 16px;
  padding: 14px 18px;
  background: transparent;
  color: var(--muted);
  font-size: 0.98rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}
.tab-button.active {
  background: var(--panel-bg);
  color: var(--ink);
  box-shadow: 0 10px 24px rgba(21, 50, 59, 0.08);
}
.auth-section {
  padding: 24px;
  border-radius: 24px;
  background:
    linear-gradient(
      180deg,
      rgba(246, 242, 233, 0.72),
      rgba(239, 230, 212, 0.42));
  border: 1px solid rgba(216, 205, 185, 0.9);
}
.section-copy {
  margin-bottom: 20px;
}
.section-copy h3 {
  margin: 0 0 10px;
  color: var(--ink);
  font-size: 1.35rem;
}
.section-copy p {
  margin: 0;
  color: var(--muted);
  line-height: 1.6;
}
.provider-grid {
  display: grid;
  gap: 12px;
  margin-bottom: 18px;
}
.field {
  margin-bottom: 16px;
  text-align: left;
}
.field label {
  display: block;
  margin-bottom: 8px;
  color: var(--ink);
  font-weight: 600;
}
.field input[pInputText],
.field .p-inputtext,
.field .p-password-input {
  width: 100%;
}
.field p-password {
  display: block;
  width: 100%;
}
.form-actions {
  display: grid;
  gap: 12px;
  margin-top: 18px;
}
.otp-section {
  background:
    linear-gradient(
      180deg,
      rgba(215, 240, 235, 0.45),
      rgba(246, 242, 233, 0.88));
}
.otp-meta {
  margin-top: 10px;
  font-size: 0.9rem;
  color: var(--brand-deep);
}
.text-link {
  margin-top: 16px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--accent);
  font-weight: 700;
  cursor: pointer;
}
.text-link:hover {
  text-decoration: underline;
}
.p-error {
  display: block;
  margin-top: 6px;
  font-size: 0.82rem;
}
:host ::ng-deep .auth-button {
  width: 100%;
}
:host ::ng-deep .auth-button .p-button {
  width: 100%;
  justify-content: center;
  border-radius: 16px;
  padding: 0.95rem 1rem;
  font-weight: 700;
}
:host ::ng-deep .p-button.tamer-button,
:host ::ng-deep .p-button.primary-action {
  background: #0f6b53 !important;
  border-color: #0f6b53 !important;
  color: #ffffff !important;
}
:host ::ng-deep .p-button.tamer-button:hover,
:host ::ng-deep .p-button.primary-action:hover {
  background: #0b5743 !important;
  border-color: #0b5743 !important;
  color: #ffffff !important;
}
:host ::ng-deep .p-button.provider-button {
  background: var(--panel-bg);
  color: var(--ink);
  border: 1px solid rgba(21, 50, 59, 0.14);
}
:host ::ng-deep .p-button.google-button {
  background: #d93025 !important;
  color: #ffffff !important;
  border-color: #d93025 !important;
}
:host ::ng-deep .p-button.google-button:hover {
  background: #c5221f !important;
  border-color: #c5221f !important;
  color: #ffffff !important;
}
:host ::ng-deep .p-button.microsoft-button {
  background: #2b579a !important;
  color: #ffffff !important;
  border-color: #2b579a !important;
}
:host ::ng-deep .p-button.microsoft-button:hover {
  background: #22467a !important;
  border-color: #22467a !important;
  color: #ffffff !important;
}
:host ::ng-deep .p-button.provider-button:not(.google-button):not(.microsoft-button):hover,
:host ::ng-deep .p-button.secondary-action:hover {
  background: var(--surface-accent) !important;
}
:host ::ng-deep .p-button.secondary-action {
  color: var(--ink);
  border-color: rgba(21, 50, 59, 0.18);
}
:host ::ng-deep .p-button.email-toggle-button {
  background: var(--brand-soft) !important;
  border-color: rgba(13, 109, 102, 0.18) !important;
}
:host ::ng-deep .p-password input {
  width: 100%;
}
@media (max-width: 640px) {
  .login-panel {
    padding: 22px;
    border-radius: 22px;
  }
  .auth-section {
    padding: 18px;
  }
  .app-title {
    font-size: 1.7rem;
  }
  .login-tabs {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=login.component-TEDA2BVK.css.map */
